import React, { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  Grid,
  Box,
  Typography,
  Button,
  Backdrop,
  CircularProgress,
} from '@mui/material';
import FormInputText from '../../../common/Forms/FormTextField';
import FormInputDropdown from '../../../common/Forms/FormDropdown';
import FormInputRadio from '../../../common/Forms/FormRadio';
import {
  admittedToProgramOnOptions,
  authTypeRadio,
  dischargeWasOptions,
  EPISODE_STS_ALERT_UPDATE_URL,
  EPISODE_STS_ALERT_URL,
  fieldRequired,
  formDateFormat,
  missedAppointmentOnOptions,
  maxLength
} from '../../../../constants';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { useForm, useWatch } from 'react-hook-form';
import {
  setAdmissionMode,
  setAdmittedToProgramOn,
  setAlertAptType,
  setAlertAptTypOth,
  setAlertAthType,
  setAlertDate,
  setAlertDischOthRsn,
  setAlertEmerCareDate,
  setAlertUADate,
  setBehavioralOrTreatmentCaseConference,
  setCbpContact,
  setCbpProgram,
  setComment,
  setDichargedFromProgramOn,
  setDischargeMode,
  setDischargeReason,
  setEmergencyMedicalCareAt,
  setMissedAppointmentOn,
  setUrinalysisFor,
} from '../../../../redux/episode/stsAlertTab/stsAlertForm';
import { postStopApi, setStopApi, deleteStopApi } from '../../../../services/StopApi/StopApi';
import {
  DialogHeader,
  DialogHeading,
  ButtonWrapper,
  CancelButton,
  DeleteButton,
  SaveButton,
} from '../../Episode.Styled';
import FormSuccess from '../../../common/Forms/FormSuccess';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
//import _ from 'lodash';
import PrintAlertDialog from './print/PrintAlertDialog';

const schema = yup.object().shape({
  alertDate: yup.date().typeError(fieldRequired).required(),
  //admittedToProgramOn: yup.date().typeError(fieldRequired).required(),
  //missedAppointmentOn: yup.date().typeError(fieldRequired).required(),
  //dichargedFromProgramOn: yup.date().typeError(fieldRequired).required(),
  //alertUADate: yup.date().typeError(fieldRequired).required(),
  //alertEmerCareDate: yup.date().typeError(fieldRequired).required(),
  //cbpProgram: yup.string().required(fieldRequired),
  //cbpContact: yup.string().required(fieldRequired),
  //urinalysisFor: yup.string().required(fieldRequired),
  urinalysisFor: yup.string().nullable().max(50, `${maxLength} 50`),

  //emergencyMedicalCareAt: yup.string().required(fieldRequired),
  emergencyMedicalCareAt: yup.string().nullable().max(50, `${maxLength} 50`),

  //BehavioralOrTreatmentCaseConference: yup.string().required(fieldRequired),
  BehavioralOrTreatmentCaseConference: yup.string().nullable().max(400, `${maxLength} 400`),
  //comment: yup.string().required(fieldRequired),
  comment: yup.string().nullable().max(255, `${maxLength} 255`),
  
  //alertDischOthRsn: yup.string().required(fieldRequired),
  alertDischOthRsn: yup.string().nullable().max(50, `${maxLength} 50`),

  //alertAptTypOth: yup.string().required(fieldRequired),
  alertAptTypOth: yup.string().nullable().max(50, `${maxLength} 50`),
  
  //alertAptType: yup.string().required(fieldRequired),
  //alertAthType: yup.string().required(fieldRequired),
  //dischargeReason: yup.string().required(fieldRequired),
  //admissionMode: yup.string().required(fieldRequired),
  //dischargeMode: yup.string().required(fieldRequired),
});

const StsAlertDialog = (props) => {
  const [openPrintAlertDialog, setOpenPrintAlertDialog] = useState(false);
  const participantInfo = useSelector((state) => state?.participants?.participantsDetail);
  const dispatch = useDispatch();
  const [formSuccess, setFormSuccess] = useState(false);
  const [isNewStsAlert, setIsNewStsAlert] = useState(false);
  const stsAlertReferenceData = useSelector(
    (state) => state.stsAlertReferenceData
  );
  const stsAlertFormData = useSelector((state) => state.stsAlertForm);
  const { open, setOpen, authToken, episodeId, openBackdrop, fetchData } =
    props;
  const defaultValue = {
    alertID: stsAlertFormData?.alertID,
    alertDate: moment(stsAlertFormData?.alertDate).format(formDateFormat),
    cbpProgram: stsAlertFormData?.cbpProgram?.orgKey,
    cbpContact: stsAlertFormData?.cbpContact?.cntKey,
    admittedToProgramOn: moment(stsAlertFormData?.admittedToProgramOn).format(
      formDateFormat
    ),
    urinalysisFor: stsAlertFormData?.urinalysisFor,
    emergencyMedicalCareAt: stsAlertFormData?.emergencyMedicalCareAt,
    missedAppointmentOn: moment(stsAlertFormData?.missedAppointmentOn).format(
      formDateFormat
    ),
    dichargedFromProgramOn: moment(
      stsAlertFormData?.dichargedFromProgramOn
    ).format(formDateFormat),
    BehavioralOrTreatmentCaseConference:
      stsAlertFormData?.BehavioralOrTreatmentCaseConference,
    comment: stsAlertFormData?.comment,
    alertDischOthRsn: stsAlertFormData?.alertDischOthRsn,
    alertAptTypOth: stsAlertFormData?.alertAptTypOth,
    alertUADate: moment(stsAlertFormData?.alertUADate).format(formDateFormat),
    alertEmerCareDate: moment(stsAlertFormData?.alertEmerCareDate).format(
      formDateFormat
    ),
    alertAptType: stsAlertFormData?.alertAptType,
    alertAthType: stsAlertFormData?.alertAthType,
    dischargeReason: stsAlertFormData?.dischargeReason,
    admissionMode: stsAlertFormData?.admissionMode,
    dischargeMode: stsAlertFormData?.dischargeMode,
    statusAlertCreatedBy: stsAlertFormData?.statusAlertCreatedBy?.value,
    editedBy: stsAlertFormData?.editedBy?.value,
    alertCreatedDate: stsAlertFormData?.alertCreatedDate,
    alertEditedDate: stsAlertFormData?.alertEditedDate,
  };
  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(schema),
  });
  const { handleSubmit, reset, control, setValue, watch, register, formState } =
    useFunction;
  const { isValid, dirtyFields, errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.alertID,
    defaultValue.alertDate,
    defaultValue.cbpProgram,
    defaultValue.cbpContact,
    defaultValue.admittedToProgramOn,
    defaultValue.urinalysisFor,
    defaultValue.emergencyMedicalCareAt,
    defaultValue.missedAppointmentOn,
    defaultValue.dichargedFromProgramOn,
    defaultValue.BehavioralOrTreatmentCaseConference,
    defaultValue.comment,
    defaultValue.alertDischOthRsn,
    defaultValue.alertAptTypOth,
    defaultValue.alertUADate,
    defaultValue.alertEmerCareDate,
    defaultValue.alertAptType,
    defaultValue.alertAthType,
    defaultValue.dischargeReason,
    defaultValue.admissionMode,
    defaultValue.statusAlertCreatedBy,
    defaultValue.editedBy,
    defaultValue.alertCreatedDate,
    defaultValue.alertEditedDate,
  ]);

  const cbpContact = useWatch({
    control,
    name: 'cbpContact',
  });

  const cbpContactId = stsAlertReferenceData?.cbpContactList?.filter((item) =>
    item.cntKey === cbpContact ? item.cntID : ''
  );
  const cbpContactValues = {
    cntID: cbpContactId[0]?.cntID,
    cntKey: cbpContactId[0]?.cntKey,
    orgKey: cbpContactId[0]?.orgKey,
  };

  const cbpProgram = useWatch({
    control,
    name: 'cbpProgram',
  });

  const cbpProgramId = stsAlertReferenceData?.cbpProgramList?.filter((item) =>
    item.orgKey === cbpProgram ? item.orgId : ''
  );
  const cbpProgramValues = {
    orgId: cbpProgramId[0]?.orgId,
    orgKey: cbpProgramId[0]?.orgKey,
  };

  useEffect(() => {
    //console.log(stsAlertFormData);
    dispatch(setCbpContact(cbpContactValues));
    dispatch(setCbpProgram(cbpProgramValues));
  }, [cbpContact, cbpProgram]);

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
  };

  const handleDelete = () => {
    const alertID = stsAlertFormData?.alertID;
    const url = `${EPISODE_STS_ALERT_URL}/${alertID}`;
    const authorization = authToken;
    const payload = {};
    deleteStopApi({ url, payload, authorization }).then((response) => {
      if (response.succeeded === true) {
        fetchData();
        handleClose();
      }
    }).catch((e) => alert(e));
  };
  
  const onSubmit = () => {
    const url = `${EPISODE_STS_ALERT_UPDATE_URL}/${episodeId}/StatusAlert`;
    const authorization = authToken;
      console.log('### stsAlertFormData');
      console.log(stsAlertFormData);
    const payload = {
      alertID: stsAlertFormData?.alertID,
      epdID: episodeId,
      altEditCntId: stsAlertFormData?.altEditCntId,
      alertAptType: `${stsAlertFormData?.alertAptType}`,
      alertDate: stsAlertFormData?.alertDate,
      missedAppointmentOn: stsAlertFormData?.missedAppointmentOn,
      altDsc: stsAlertFormData?.altDsc ? stsAlertFormData?.altDsc : null,
      comment: stsAlertFormData?.comment,
      altFlagYN: stsAlertFormData?.altFlagYN,
      altInactiveYN: stsAlertFormData?.altInactiveYN,
      altCbpOrgID: stsAlertFormData?.cbpProgram?.orgId,
      admittedToProgramOn:
          stsAlertFormData?.admittedToProgramOn === ''
            ? null
            : stsAlertFormData?.admittedToProgramOn,
        dichargedFromProgramOn:
          stsAlertFormData?.dichargedFromProgramOn === ''
            ? null
            : stsAlertFormData?.dichargedFromProgramOn,
      //admissionMode: stsAlertFormData?.admissionMode === "null" ? null : stsAlertFormData?.admissionMode,
      //dischargeMode: stsAlertFormData?.dischargeMode === "null" ? null : stsAlertFormData?.dischargeMode,
      admissionMode: stsAlertFormData?.admissionMode === null || stsAlertFormData?.admissionMode === "null" ? null : `${stsAlertFormData?.admissionMode}`,
      dischargeMode: stsAlertFormData?.dischargeMode === null || stsAlertFormData?.dischargeMode === "null" ? null : `${stsAlertFormData?.dischargeMode}`,
      altCbpCntID: stsAlertFormData?.cbpContact?.cntID,
      dischargeReason: stsAlertFormData?.dischargeReason,
      alertDischOthRsn: stsAlertFormData?.alertDischOthRsn,
      alertAptTypOth: stsAlertFormData?.alertAptTypOth,
      altCreateCntId: stsAlertFormData?.altCreateCntId,
      alertAthType: stsAlertFormData?.alertAthType,
      urinalysisFor: stsAlertFormData?.urinalysisFor,
      alertUADate: stsAlertFormData?.alertUADate,
      emergencyMedicalCareAt: stsAlertFormData?.emergencyMedicalCareAt,
      alertEmerCareDate: stsAlertFormData?.alertEmerCareDate,
      BehavioralOrTreatmentCaseConference:
        stsAlertFormData?.BehavioralOrTreatmentCaseConference,
    };
    if (stsAlertFormData?.newStsAlert === true) {
      const payload = {
        alertID: 0,
        epdID: episodeId,
        altEditCntId: 13274,
        alertAptType: `${
          stsAlertFormData?.alertAptType === ''
            ? null
            : stsAlertFormData?.alertAptType
        }`,
        alertDate:
          stsAlertFormData?.alertDate === ''
            ? null
            : stsAlertFormData?.alertDate,
        missedAppointmentOn:
          stsAlertFormData?.missedAppointmentOn === ''
            ? null
            : stsAlertFormData?.missedAppointmentOn,
        altDsc:
          stsAlertFormData?.altDsc == '' ? null : stsAlertFormData?.altDsc,
        comment:
          stsAlertFormData?.comment === '' ? null : stsAlertFormData?.comment,
        altFlagYN:
          stsAlertFormData?.altFlagYN == ''
            ? null
            : stsAlertFormData?.altFlagYN,
        altInactiveYN:
          stsAlertFormData?.altInactiveYN == ''
            ? null
            : stsAlertFormData?.altInactiveYN,
        altCbpOrgID:
          stsAlertFormData?.cbpProgram?.orgId === ''
            ? null
            : stsAlertFormData?.cbpProgram?.orgId,
        admittedToProgramOn:
          stsAlertFormData?.admittedToProgramOn === ''
            ? null
            : stsAlertFormData?.admittedToProgramOn,
        dichargedFromProgramOn:
          stsAlertFormData?.dichargedFromProgramOn === ''
            ? null
            : stsAlertFormData?.dichargedFromProgramOn,
        admissionMode: 
          stsAlertFormData?.admissionMode === null || stsAlertFormData?.admissionMode === 'null'
            ? null
            : `${stsAlertFormData?.admissionMode}`
        ,
        dischargeMode: 
          stsAlertFormData?.dischargeMode === null || stsAlertFormData?.dischargeMode === 'null'
            ? null
            : `${stsAlertFormData?.dischargeMode}`
        ,
        altCbpCntID:
          stsAlertFormData?.cbpContact?.cntID === ''
            ? null
            : stsAlertFormData?.cbpContact?.cntID,
        dischargeReason:
          stsAlertFormData?.dischargeReason === ''
            ? null
            : stsAlertFormData?.dischargeReason,
        alertDischOthRsn:
          stsAlertFormData?.alertDischOthRsn === ''
            ? null
            : stsAlertFormData?.alertDischOthRsn,
        alertAptTypOth:
          stsAlertFormData?.alertAptTypOth === ''
            ? null
            : stsAlertFormData?.alertAptTypOth,
        altCreateCntId: 13274,
        alertAthType:
          stsAlertFormData?.alertAthType === ''
            ? null
            : stsAlertFormData?.alertAthType,
        urinalysisFor:
          stsAlertFormData?.urinalysisFor === ''
            ? null
            : stsAlertFormData?.urinalysisFor,
        alertUADate:
          stsAlertFormData?.alertUADate === ''
            ? null
            : stsAlertFormData?.alertUADate,
        emergencyMedicalCareAt:
          stsAlertFormData?.emergencyMedicalCareAt === ''
            ? null
            : stsAlertFormData?.emergencyMedicalCareAt,
        alertEmerCareDate:
          stsAlertFormData?.alertEmerCareDate === ''
            ? null
            : stsAlertFormData?.alertEmerCareDate,
        BehavioralOrTreatmentCaseConference:
          stsAlertFormData?.BehavioralOrTreatmentCaseConference === ''
            ? null
            : stsAlertFormData?.BehavioralOrTreatmentCaseConference,
      };
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNewStsAlert(true);
        }
      }).catch((e) => alert(e));
    } else {
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          setFormSuccess(true);
          setIsNewStsAlert(false);
          fetchData();
        }
      }).catch((e) => alert(e));
    }
    setOpen(false);
  };

  const handlePrintAlert = () => {
    setOpenPrintAlertDialog(true);
  };

  const onError = () => {
    alert('Unable to Save. Please check for field validation errors.')
  }

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            maxWidth: 'unset',
            width: '1000px',
            maxHeight: '90vh',
            '&::-webkit-scrollbar': { display: 'none' },
          },
        }}
      >
        {openBackdrop ? (
          <Backdrop
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openBackdrop}
          >
            <CircularProgress />
          </Backdrop>
        ) : (
          <>
            <DialogHeader>
              <DialogHeading variant='h5'>Status Alert: {participantInfo[0].key}</DialogHeading>
              <Box>
                <Button variant='contained' onClick={handlePrintAlert}>
                  Print View
                </Button>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogHeader>
            <Grid container spacing={2} style={{ padding: '10px 40px' }}>
              <Grid
                item
                xs={12}
                sm={6}
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <FormInputText
                  name='alertDate'
                  control={control}
                  type='date'
                  label='Alert date'
                  shrink={true}
                  register={register('alertDate', {
                    onBlur: (e) => dispatch(setAlertDate(e.target.value)),
                  })}
                  errors={!!errors.alertDate}
                  helperText={errors?.alertDate?.message}
                />
                {/* <FormInputText
                  name='alertID'
                  control={control}
                  type='text'
                  label='Alert ID'
                  disabled={true}
                  // register={register('participantName', {
                  //   onChange: (e) => dispatch(setParticipantName(e.target.value)),
                  // })}
                  // error={!!errors.participantName}
                  // helperText={errors?.eprd?.message}
                /> */}
                <FormInputDropdown
                  name='cbpProgram'
                  control={control}
                  label='From (Name of CBP Program)'
                  options={stsAlertReferenceData?.cbpProgramList}
                  cbpProgram={true}
                  errors={!!errors.cbpProgram}
                  helperText={errors?.cbpProgram?.message}
                />
                <FormInputDropdown
                  name='cbpContact'
                  control={control}
                  label='CBP Contact'
                  options={stsAlertReferenceData?.cbpContactList}
                  cbpContact={true}
                  errors={!!errors.cbpContact}
                  helperText={errors?.cbpContact?.message}
                />
                <FormInputText
                  name='missedAppointmentOn'
                  control={control}
                  type='date'
                  label='Missed appointment on'
                  shrink={true}
                  register={register('missedAppointmentOn', {
                    onBlur: (e) =>
                      dispatch(setMissedAppointmentOn(e.target.value)),
                  })}
                  errors={!!errors.missedAppointmentOn}
                  helperText={errors?.missedAppointmentOn?.message}
                />
                <FormInputText
                  name='BehavioralOrTreatmentCaseConference'
                  control={control}
                  type='text'
                  label='Behavioral/treatment issues exist which may necessitate a case conference - please contact provider'
                  multiline={true}
                  rows={3.5}
                  register={register('BehavioralOrTreatmentCaseConference', {
                    onBlur: (e) =>
                      dispatch(
                        setBehavioralOrTreatmentCaseConference(e.target.value)
                      ),
                  })}
                  errors={!!errors.BehavioralOrTreatmentCaseConference}
                  helperText={
                    errors?.BehavioralOrTreatmentCaseConference?.message
                  }
                />
                <FormInputRadio
                  name='dischargeReason'
                  control={control}
                  options={dischargeWasOptions}
                  label='Discharge Was:'
                  errors={!!errors.dischargeReason}
                  helperText={errors?.dischargeReason?.message}
                  register={register('dischargeReason', {
                    onChange: (e) => {
                      if (e.target.value==99) {
                        reset(defaultValue)
                        dispatch(setDischargeReason(''))
                      }
                      else
                        dispatch(setDischargeReason(Number.parseInt(e.target.value)))
                    }
                  })}
                />
                <FormInputText
                  name='alertDischOthRsn'
                  type='text'
                  control={control}
                  register={register('alertDischOthRsn', {
                    onBlur: (e) =>
                      dispatch(setAlertDischOthRsn(e.target.value)),
                  })}
                  errors={!!errors.alertDischOthRsn}
                  helperText={errors?.alertDischOthRsn?.message}
                />
                <FormInputRadio
                  name='alertAptType'
                  control={control}
                  options={missedAppointmentOnOptions}
                  label='Missed appointment on :'
                  errors={!!errors.alertAptType}
                  helperText={errors?.alertAptType?.message}
                  register={register('alertAptType', {
                    onChange: (e) => {
                      if (e.target.value==99) {
                        reset(defaultValue)
                        dispatch(setAlertAptType(''))
                      }
                      else                      
                        dispatch(setAlertAptType(Number.parseInt(e.target.value)))
                    }
                  })}
                />
                <FormInputText
                  name='alertAptTypOth'
                  type='text'
                  control={control}
                  register={register('alertAptTypOth', {
                    onBlur: (e) =>
                      dispatch(setAlertAptTypOth(e.target.value)),
                  })}
                  errors={!!errors.alertAptTypOth}
                  helperText={errors?.alertAptTypOth?.message}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                {/* <Typography variant='h6' style={{ marginBottom: '10px' }}>
                  Submitted urinalysis which yielded positive for:
                </Typography> */}
                <FormInputText
                  name='urinalysisFor'
                  type='text'
                  control={control}
                  label='Submitted urinalysis which yielded positive for'
                  register={register('urinalysisFor', {
                    onBlur: (e) => dispatch(setUrinalysisFor(e.target.value)),
                  })}
                  errors={!!errors.urinalysisFor}
                  helperText={errors?.urinalysisFor?.message}
                />
                <FormInputText
                  name='alertUADate'
                  type='date'
                  control={control}
                  label='on'
                  shrink={true}
                  register={register('alertUADate', {
                    onBlur: (e) => dispatch(setAlertUADate(e.target.value)),
                  })}
                  errors={!!errors.alertUADate}
                  helperText={errors?.alertUADate?.message}
                />
                {/* <Typography variant='h6' style={{ marginBottom: '10px' }}>
                  Sought Emergency medical care at:
                </Typography> */}
                <FormInputText
                  name='emergencyMedicalCareAt'
                  type='text'
                  control={control}
                  label='Sought emergency medical care at'
                  register={register('emergencyMedicalCareAt', {
                    onBlur: (e) =>
                      dispatch(setEmergencyMedicalCareAt(e.target.value)),
                  })}
                  errors={!!errors.emergencyMedicalCareAt}
                  helperText={errors?.emergencyMedicalCareAt?.message}
                />
                <FormInputText
                  name='alertEmerCareDate'
                  type='date'
                  control={control}
                  label='on'
                  shrink={true}
                  register={register('alertEmerCareDate', {
                    onBlur: (e) =>
                      dispatch(setAlertEmerCareDate(e.target.value)),
                  })}
                  errors={!!errors.alertEmerCareDate}
                  helperText={errors?.alertEmerCareDate?.message}
                />
                <FormInputText
                  name='comment'
                  control={control}
                  type='text'
                  label='comment'
                  multiline={true}
                  rows={3.5}
                  register={register('comment', {
                    onBlur: (e) => dispatch(setComment(e.target.value)),
                  })}
                  errors={!!errors.comment}
                  helperText={errors?.comment?.message}
                />
                <FormInputText
                  name='admittedToProgramOn'
                  control={control}
                  type='date'
                  shrink={true}
                  label='Admitted to program on'
                  register={register('admittedToProgramOn', {
                    onBlur: (e) =>
                      dispatch(setAdmittedToProgramOn(e.target.value)),
                  })}
                  errors={!!errors.admittedToProgramOn}
                  helperText={errors?.admittedToProgramOn?.message}
                />
                <FormInputText
                  name='dichargedFromProgramOn'
                  type='date'
                  control={control}
                  label='Discharged from program on'
                  shrink={true}
                  register={register('dichargedFromProgramOn', {
                    onBlur: (e) =>
                      dispatch(setDichargedFromProgramOn(e.target.value)),
                  })}
                  errors={!!errors.dichargedFromProgramOn}
                  helperText={errors?.dichargedFromProgramOn?.message}
                />
                <FormInputRadio
                  name='admissionMode'
                  control={control}
                  options={admittedToProgramOnOptions}
                  label='Admitted to program on :'
                  errors={!!errors.admissionMode}
                  helperText={errors?.admissionMode?.message}
                  register={register('admissionMode', {
                    onChange: (e) => {
                      //console.log('existting value: ' + defaultValue.admissionMode)
                      //console.log('new value: ' + e.target.value)
                      if (e.target.value==99) {
                        reset(defaultValue)
                        dispatch(setAdmissionMode(''))
                      }
                      else
                        dispatch(setAdmissionMode(Number.parseInt(e.target.value)))
                    }
                  })}                  
                />
                <FormInputRadio
                  name='dischargeMode'
                  control={control}
                  options={admittedToProgramOnOptions}
                  label='Dicharged from program on :'
                  errors={!!errors.dischargeMode}
                  helperText={errors?.dischargeMode?.message}
                  register={register('dischargeMode', {
                    onChange: (e) => {
                      if (e.target.value==99) {
                        reset(defaultValue)
                        dispatch(setDischargeMode(''))
                      }
                      else
                        dispatch(setDischargeMode(Number.parseInt(e.target.value)))
                    }
                  })}
                />
                <Typography variant='h6'>Auth Type:</Typography>
                <FormInputRadio
                  name='alertAthType'
                  control={control}
                  options={authTypeRadio}
                  errors={!!errors.alertAthType}
                  helperText={errors?.alertAthType?.message}
                  isRadio={true}
                  register={register('alertAthType', {
                    onChange: (e) => {
                      if (e.target.value==99) {
                        reset(defaultValue)
                        dispatch(setAlertAthType(0))
                      }
                      else
                        dispatch(setAlertAthType(Number.parseInt(e.target.value)))
                    }  
                  })}
                />
              </Grid>
              <ButtonWrapper>
                <CancelButton
                  variant='contained'
                  //disabled={_.isEmpty(dirtyFields) || !isValid}
                  onClick={handleClose}
                >
                  Cancel
                </CancelButton>
                {stsAlertFormData?.alertID != 0 && (
                  <DeleteButton
                    variant="contained"
                    disabled={defaultValue.authIsLocked}
                    onClick={handleDelete}
                  >
                    Delete
                  </DeleteButton>
                )}
                <SaveButton
                  variant='contained'
                  //disabled={_.isEmpty(dirtyFields) || !isValid}
                  onClick={handleSubmit(onSubmit, onError)}
                >
                  Save
                </SaveButton>
              </ButtonWrapper>
            </Grid>
          </>
        )}
      </Dialog>
      <FormSuccess
        formSuccess={formSuccess}
        setFormSuccess={setFormSuccess}
        isNewForm={isNewStsAlert}
      />
      <PrintAlertDialog
        open={openPrintAlertDialog}
        setOpen={setOpenPrintAlertDialog}
      />
    </>
  );
};

export default StsAlertDialog;
